import { getDeepOr } from './helpers'

const RepresentativeNetwork = Object.freeze({
  NOT_LIMITED: 'NOT_LIMITED',
  LIMITED: 'LIMITED',
})

export const isLimitedNetwork = storeInfo =>
  getDeepOr(
    RepresentativeNetwork.LIMITED,
    storeInfo,
    'currentRepresentative.representativeNetwork',
  ) === RepresentativeNetwork.LIMITED
